import { TableDataSort } from 'constants/_types/TableDataSort';

const parseSortForBE = (sort: TableDataSort | null): string => {
  if (!sort) return '';
  return sort.direction === 'desc' ? `-${sort.key}` : sort.key;
};

export default parseSortForBE;
